// extracted by mini-css-extract-plugin
export var dividerContainer = "_a5-0";
export var line = "_a5-1";